import { createFileRoute } from "@tanstack/react-router";
import { lazyNamed } from "@/lib/lazy-route";
import { COMMERCIAL_STRUCTURAL_FAQS } from "@/components/landing/lp-commercial-structural";

import { breadcrumbJsonLdScript, commercialBreadcrumbTrail } from "@/lib/breadcrumbs";
import { pageSeo, serviceJsonLdScript } from "@/lib/seo";
import { SITE } from "@/lib/site";

const LpCommercialStructuralPage = lazyNamed(
  () => import("@/components/landing/lp-commercial-structural"),
  "LpCommercialStructural",
);

const PATH = "/commercial-structural";
const TITLE =
  "Structural & Remedial Programmes South Wales & South West | Framework-Ready | CRS Energy";
const DESCRIPTION =
  "Portfolio structural surveys and remedial works for councils, housing associations and landlords. Wall ties, cavity inspection, movement assessment, building-control liaison and completion documentation.";
const BREADCRUMB_NAME = "Structural & Remedial Programmes";

export const Route = createFileRoute("/commercial-structural")({
  head: () => ({
    ...pageSeo({
      path: PATH,
      title: TITLE,
      description: DESCRIPTION,
      ogType: "article",
    }),
    scripts: [
      serviceJsonLdScript({
        name: BREADCRUMB_NAME,
        description: DESCRIPTION,
        serviceType: "Structural & Remedial Programmes",
        url: `${SITE.url}${PATH}`,
      }),
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: COMMERCIAL_STRUCTURAL_FAQS.map((f) => ({
            "@type": "Question",
            name: f.question,
            acceptedAnswer: { "@type": "Answer", text: f.answer },
          })),
        }),
      },
      breadcrumbJsonLdScript(commercialBreadcrumbTrail(BREADCRUMB_NAME, PATH)),
    ],
  }),
  component: LpCommercialStructuralPage,
});
